import React from 'react';
import Input from '../../UI/Input';
import Button from '../../UI/Button';

const DEGREE_OPTIONS = ["Bachelor's", "Master's", 'PhD', 'Associate', 'Diploma', 'Certificate'];

export default function EducationForm({ education = [], onChange }) {
	const items = education || [];

	function add() {
		onChange([...(items || []), { institution: '', degree: '', field: '', startDate: '', endDate: '', gpa: '', activities: [], description: '' }]);
	}
	function remove(i) {
		onChange(items.filter((_, idx) => idx !== i));
	}
	function move(i, dir) {
		const j = i + dir;
		if (j < 0 || j >= items.length) return;
		const next = [...items];
		[next[i], next[j]] = [next[j], next[i]];
		onChange(next);
	}
	function update(i, key, value) {
		const next = [...items];
		next[i] = { ...next[i], [key]: value };
		onChange(next);
	}
	function addActivity(i, text) {
		const next = [...items];
		const arr = Array.isArray(next[i].activities) ? next[i].activities : [];
		next[i].activities = [...arr, text];
		onChange(next);
	}
	function removeActivity(i, idx) {
		const next = [...items];
		next[i].activities = (next[i].activities || []).filter((_, k) => k !== idx);
		onChange(next);
	}

	return (
		<div className="space-y-4">
			{!items.length && <div className="text-sm text-gray-500">No education added yet.</div>}
			{items.map((ed, i) => (
				<div key={i} className="border rounded-md p-4 space-y-3">
					<div className="flex items-center justify-between">
						<div className="text-sm text-gray-500">{ed.degree ? `${ed.degree} in ${ed.field}` : ''}</div>
						<div className="flex items-center gap-2">
							<Button variant="ghost" onClick={() => move(i, -1)} disabled={i === 0}>
								Up
							</Button>
							<Button variant="ghost" onClick={() => move(i, 1)} disabled={i === items.length - 1}>
								Down
							</Button>
							<Button variant="ghost" onClick={() => remove(i)}>
								Remove
							</Button>
						</div>
					</div>
					<div className="grid grid-cols-1 md:grid-cols-2 gap-3">
						<Input name="institution" label="Institution" value={ed.institution || ''} onChange={(e) => update(i, 'institution', e.target.value)} required />
						<div>
							<label className="block text-sm font-medium text-gray-700 mb-1">Degree</label>
							<select
								className="w-full rounded-md border border-gray-300 px-3 py-2"
								value={ed.degree || ''}
								onChange={(e) => update(i, 'degree', e.target.value)}
							>
								<option value="">Select degree</option>
								{DEGREE_OPTIONS.map((opt) => (
									<option key={opt} value={opt}>
										{opt}
									</option>
								))}
							</select>
						</div>
						<Input name="field" label="Field of Study" value={ed.field || ''} onChange={(e) => update(i, 'field', e.target.value)} required />
						<div className="grid grid-cols-2 gap-3">
							<Input name="startDate" label="Start (YYYY-MM)" value={ed.startDate || ''} onChange={(e) => update(i, 'startDate', e.target.value)} />
							<Input name="endDate" label="End (YYYY-MM or Expected)" value={ed.endDate || ''} onChange={(e) => update(i, 'endDate', e.target.value)} />
						</div>
						<Input name="gpa" label="GPA (optional)" value={ed.gpa || ''} onChange={(e) => update(i, 'gpa', e.target.value)} />
						<div className="md:col-span-2">
							<label className="block text-sm font-medium text-gray-700 mb-1">Achievements / Activities</label>
							<ActivityChips items={ed.activities || []} onAdd={(t) => addActivity(i, t)} onRemove={(k) => removeActivity(i, k)} />
						</div>
						<div className="md:col-span-2">
							<label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
							<textarea
								className="w-full rounded-md border border-gray-300 px-3 py-2"
								rows="3"
								value={ed.description || ''}
								onChange={(e) => update(i, 'description', e.target.value)}
							/>
						</div>
					</div>
				</div>
			))}
			<Button variant="ghost" onClick={add}>
				Add Education
			</Button>
		</div>
	);
}

function ActivityChips({ items, onAdd, onRemove }) {
	const [val, setVal] = React.useState('');
	function onKeyDown(e) {
		if (e.key === 'Enter') {
			e.preventDefault();
			if (!val.trim()) return;
			onAdd(val.trim());
			setVal('');
		}
	}
	return (
		<div>
			<div className="flex flex-wrap gap-2">
				{(items || []).map((s, i) => (
					<span key={i} className="px-2 py-0.5 bg-gray-100 rounded text-xs">
						{s}{' '}
						<button type="button" className="ml-1 text-red-600" onClick={() => onRemove(i)}>
							×
						</button>
					</span>
				))}
			</div>
			<input
				className="mt-2 w-full rounded-md border border-gray-300 px-3 py-2 text-sm"
				placeholder="Type and press Enter to add"
				value={val}
				onChange={(e) => setVal(e.target.value)}
				onKeyDown={onKeyDown}
			/>
		</div>
	);
}


